// extracted by mini-css-extract-plugin
export default {"Kiosk":"Kiosk_Kiosk__D1o8F","Login__btn__container":"Kiosk_Login__btn__container__TaSI4","Login__btn":"Kiosk_Login__btn__aTEer","Kiosk__img":"Kiosk_Kiosk__img__D43EP"};